export default "__VITE_ASSET__DnWRicNN__"